import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IVehicleStockIntelligence } from "../models/Part";
import { DefaultResponseWithData } from "../models/system";

/**
 * Fetches the vehicle stock intelligence bundle for a part — supply
 * & demand metrics aggregated across vehicles of the same
 * year/make/model (and optionally mark).
 *
 * NOTE: backend endpoint is pending — see
 * `docs/pending-endpoints.md`. The query is enabled by default but
 * tolerates failure / missing data; the consuming component renders
 * an empty state when nothing comes back.
 */
export default function useVehicleStockIntelligence(
  partId: string | undefined
) {
  const { get } = useApiHelper();
  const staleTime = 1000 * 60 * 5; // 5 minutes
  const enabled = Boolean(partId);

  const intelligence = useQuery({
    queryKey: ["parts", partId, "vehicleStockIntelligence"],
    queryFn: () =>
      get<DefaultResponseWithData<IVehicleStockIntelligence>>(
        `/part/${partId}/vehicle-stock-intelligence`
      ),
    staleTime,
    refetchOnWindowFocus: false,
    retry: false,
    enabled,
  });

  return { intelligence };
}
